(() => {
  let productHelpSubscribed = false;
  const updateProductHelpLink = (link, sku = '') => {
    const url = new URL(link.dataset.contactUrl || '/pages/contact', window.location.origin);
    if (sku) url.searchParams.set('sku', sku); else url.searchParams.delete('sku');
    link.href = `${url.pathname}${url.search}${url.hash}`;
    link.dataset.productSku = sku;
  };
  const subscribeProductHelp = () => {
    if (productHelpSubscribed || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const sku = event?.data?.variant?.sku || '';
      document.querySelectorAll('[data-tn-product-help-link]').forEach(link => updateProductHelpLink(link, sku));
    });
    productHelpSubscribed = true;
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-tn-mobile-menu]:not([data-ready])').forEach(menu => {
      menu.dataset.ready = 'true';
      const summary = menu.querySelector('summary');
      const close = (restoreFocus = false) => {
        if (!menu.open) return;
        menu.open = false;
        summary?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) summary?.focus();
      };
      menu.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(menu.open)));
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !menu.open) return;
        event.preventDefault();
        close(true);
      });
      menu.addEventListener('focusout', event => { if (event.relatedTarget && !menu.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', event => { if (!menu.contains(event.target)) close(); });
    });
    scope.querySelectorAll('[data-tn-product-help-link]:not([data-ready])').forEach(link => {
      link.dataset.ready = 'true';
      updateProductHelpLink(link, link.dataset.productSku || '');
    });
    subscribeProductHelp();
    scope.querySelectorAll('[data-tn-search]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const input = root.querySelector('input[type="search"]');
      const results = root.querySelector('[role="listbox"]');
      const status = root.querySelector('[data-search-status]');
      const closeButton = root.querySelector('[data-search-close]');
      let timer, controller, selected = -1, suppressFocusSearch = false, requestRevision = 0;
      const close = () => { results.hidden = true; if (closeButton) closeButton.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); selected = -1; };
      const dismiss = () => { clearTimeout(timer); controller?.abort(); requestRevision++; close(); };
      const getSuggestions = async () => {
        controller?.abort();
        const term = input.value.trim();
        if (term.length < 2) { close(); return; }
        const currentController = new AbortController();
        controller = currentController;
        const currentRevision = ++requestRevision;
        const url = new URL(root.dataset.endpoint, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][fields]', 'title,variants.sku,product_type,vendor');
        url.searchParams.set('section_id', 'tn-predictive-search');
        try {
          const response = await fetch(url, { signal: currentController.signal });
          if (!response.ok) { if (currentRevision === requestRevision) close(); return; }
          const html = await response.text();
          if (term !== input.value.trim() || currentController.signal.aborted || currentRevision !== requestRevision || !root.contains(document.activeElement)) return;
          const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('.tn-predictive-inner');
          if (!fragment) { close(); return; }
          if (!fragment.querySelector('li')) { status.textContent = root.dataset.noResults; close(); return; }
          results.replaceChildren(...fragment.childNodes);
          results.querySelectorAll('[role="option"]').forEach((item, i) => { item.id = `${input.id}-option-${i}`; });
          results.hidden = false;
          if (closeButton) closeButton.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          selected = -1;
          status.textContent = `${results.querySelectorAll('li').length} ${root.dataset.searchLabel}`;
        } catch (error) { if (error.name !== 'AbortError' && currentRevision === requestRevision) close(); }
      };
      input.addEventListener('input', () => { dismiss(); status.textContent = ''; timer = setTimeout(getSuggestions, 180); });
      input.addEventListener('focus', () => { if (!suppressFocusSearch && input.value.trim().length > 1) getSuggestions(); });
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { dismiss(); return; }
        if (results.hidden) return;
        const items = [...results.querySelectorAll('[role="option"]')];
        if (!items.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          selected = event.key === 'ArrowDown' ? (selected + 1) % items.length : (selected < 0 ? items.length - 1 : (selected - 1 + items.length) % items.length);
          items.forEach((item, i) => item.setAttribute('aria-selected', String(i === selected)));
          input.setAttribute('aria-activedescendant', items[selected].id);
          items[selected].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && selected >= 0) { event.preventDefault(); items[selected].click(); }
      });
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) dismiss(); });
      closeButton?.addEventListener('click', () => { dismiss(); suppressFocusSearch = true; input.focus(); suppressFocusSearch = false; });
      document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) dismiss(); });
      root.querySelector('form').addEventListener('submit', event => { if (!input.value.trim()) { event.preventDefault(); input.focus(); } });
    });
    scope.querySelectorAll('[data-tn-directory]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const input = root.querySelector('[data-category-filter]');
      const index = root.querySelector('[data-category-index]');
      const status = root.querySelector('[data-category-status]');
      const pagination = root.querySelector('[data-category-pagination]');
      const more = root.querySelector('[data-category-more]');
      const initialHtml = index.innerHTML, initialStatus = status.textContent;
      const collect = node => [...node.querySelectorAll('[data-category-link]')].map(a => ({ title: a.childNodes[0].textContent.trim(), url: a.getAttribute('href') }));
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      let allPromise, timer, matches = [], shown = 100, revision = 0;
      const loadAll = () => {
        if (allPromise) return allPromise;
        const pages = Number(root.dataset.pages), current = Number(root.dataset.currentPage);
        allPromise = Promise.all(Array.from({ length: pages }, async (_, i) => {
          const page = i + 1;
          if (page === current) return collect(root);
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', root.dataset.sectionId);
          url.searchParams.set(root.dataset.pageParam || 'page', String(page));
          const response = await fetch(url);
          if (!response.ok) throw new Error('categories');
          return collect(new DOMParser().parseFromString(await response.text(), 'text/html'));
        })).then(groups => [...new Map(groups.flat().map(item => [item.url, item])).values()].sort((a,b) => a.title.localeCompare(b.title, 'it'))).catch(error => { allPromise = null; throw error; });
        return allPromise;
      };
      const render = () => {
        const fragment = document.createDocumentFragment();
        matches.slice(0, shown).forEach(item => {
          const li = document.createElement('li'), a = document.createElement('a'), arrow = document.createElement('span');
          a.href = item.url; a.textContent = item.title; arrow.textContent = '↗'; arrow.setAttribute('aria-hidden','true'); a.append(arrow); li.append(a); fragment.append(li);
        });
        index.replaceChildren(fragment); pagination.hidden = true; more.hidden = matches.length <= shown;
        status.textContent = `${matches.length} ${root.dataset.countLabel}`;
      };
      input.addEventListener('input', () => {
        clearTimeout(timer); const currentRevision = ++revision;
        if (input.value.trim().length < 2) { index.innerHTML = initialHtml; status.textContent = initialStatus; pagination.hidden = false; more.hidden = true; return; }
        timer = setTimeout(async () => {
          status.textContent = root.dataset.loadingLabel;
          try {
            const all = await loadAll();
            if (currentRevision !== revision) return;
            const terms = normalize(input.value.trim()).split(/\s+/);
            matches = all.filter(item => terms.every(term => normalize(item.title).includes(term))); shown = 100; render();
          } catch { if (currentRevision === revision) status.textContent = root.dataset.errorLabel; }
        }, 180);
      });
      more.addEventListener('click', () => { shown += 100; render(); });
    });
    const code = new URLSearchParams(window.location.search).get('sku');
    const field = scope.querySelector('#TnContact-code');
    if (code && field && !field.value) field.value = code.slice(0,120);
    const companyFields = scope.querySelector('[data-tn-company-fields]');
    if (companyFields && new URLSearchParams(window.location.search).get('cliente') === 'azienda') {
      companyFields.hidden = false;
      companyFields.querySelectorAll('input').forEach(input => { input.disabled = false; });
      const topic = scope.querySelector('[data-tn-company-topic]');
      if (topic) topic.selected = true;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
